import React, {Component, useCallback} from "react";
import $ from "jquery";
import {CommonUtil} from "../../utils/CommonUtil";
import {Constants} from "../Languages/Constants";

let customCheckout = null;
let customCheckout1 = null;
var self = null;
var cardNumber = null;
var cvv = null;
var expiry = null;
var flag = false;
export default class CreditCardDetails extends Component{

    componentDidMount() {
        self = this;
        if(!self.flag) {

        }
        console.log(customCheckout);
        customCheckout = window.customcheckout() || null;
        this.showCardDetails();

    }

    componentWillUnmount() {
        customCheckout = null;
        console.log("unmount");
        if(cardNumber){
           // cardNumber.unmount();
        }
        if(cvv){
           // cvv.unmount();
        }
        if(expiry){
           // expiry.unmount();
        }
    }

    showCardDetails = ()=>{
        setTimeout(()=>{
            // self.flag = false;
        },10000);
        if(!self.flag){
            cardNumber = customCheckout.create('card-number');
            cardNumber.mount('#card-number');
            cvv = customCheckout.create("cvv");
            cvv.mount("#card-cvv");
            expiry = customCheckout.create("expiry");
            expiry.mount("#card-expiry");

            customCheckout.on('error', function(event) {
                console.log('errors: ' + JSON.stringify(event));
                if (event.field === 'card-number') {
                    self.showInvalidMessage("card-number");
                } else if (event.field === 'cvv') {
                    self.showInvalidMessage("card-cvv");
                } else if (event.field === 'expiry') {
                    self.showInvalidMessage("card-expiry");
                }
            });
        }
    }

    showInvalidMessage = (divId)=>{
        if(!$("#"+divId).hasClass("is-invalid")){
            $("#"+divId).addClass("is-invalid");
        }
    }
    showValidMessage = (divId)=>{
        if($("#"+divId).hasClass("is-invalid")){
            $("#"+divId).removeClass("is-invalid");
            $("#"+divId).addClass("is-valid");
        }else{
            $("#"+divId).addClass("is-valid");
        }
    }

    static setCreditCardHolderName(strName){
        $("#cardHolderName").val(strName);
    }
    static setCreditCardHolderNo(strName){
        $("#spnCardNum").text(strName);
    }
    static setCreditCardHolderCVV(strName){
        $("#spnCardCvv").text(strName);
    }
    static setCreditCardHolderExpDate(strName){
        $("#spnCardDate").text(strName);
    }

    static setCreditCardUseAsDefault(flag){
        try{
            if(flag){
                $("#isForPayment").prop('checked', true);
            }else{
                $("#isForPayment").prop('checked', false);
            }
        }catch(e){
            console.log(e);
        }
    }

    static getCreditCardUseAsDefault(){
        try{
            return $("#isForPayment").is(':checked');
        }catch(e){
            return false;
        }
    }

    static getCardHoderName = ()=> {
        var strName = $("#cardHolderName").val();
        strName = strName.trim();
        return strName;
    }
        static getCardDetails = (fun)=>{
            var response1 = null;
            let restObj = {};

            customCheckout.createToken((response)=>{
                restObj.US = response;
                customCheckout.createToken((res)=>{
                    restObj.CANADA = res;
                    fun(restObj);
                });
            });
        }
        usCallback = function(response){
             console.log("US");
            console.log(response);
            return response;
        }
    canadaCallback = function(response){
        console.log("Canada");
        console.log(response);
        return response;
    }
    static getTokenInfo = (results)=>{
        var response1 = null;
        let restObj = {};
        let dataArray = [];
          customCheckout.createToken((response)=>{
              dataArray.push(response);
          });

       let timer =  setTimeout( ()=>{
           customCheckout.createToken((response)=>{
               dataArray.push(response);
               setTimeout(()=>{
                   if(dataArray.length == 2){
                       let copyArray = [...dataArray];
                       dataArray = [];
                       results(copyArray);

                   }

               },1000);
           });
             clearTimeout(timer);
        },1000);

        console.log("2");
    }
    static getCanadaCard = (fun)=>{
        customCheckout.createToken((res)=>{
            fun(res);
        });
    }

        onClickPay = ()=>{
            customCheckout.createToken((res)=>{
                console.log(res);
            });
        }



        render() {
            return(
                <>
                    <div className="row fs-7 clsFormStandardTopMargin">
                        <div className="row">
                          <div className="col-md-4">
                              <label className="col-form-label">{CommonUtil.getMessageText(Constants.CARD_HOLDER_NAME,"Card Holder Name")}</label>
                              <input  id="cardHolderName" type="text" className="form-control" placeholder="Card Holder Name"   />

                          </div>
                          <div className="col-md-4">
                              <label className="col-form-label">{CommonUtil.getMessageText(Constants.CARD_NUMBER,"Card Number")}</label>
                              <div id="card-number" className="field form-control"
                                  placeholder="Card Number" style={{backgroundRepeat:"no-repeat"}}></div>
                              <span style={{color:"red"}} id={"spnCardNum"}></span>
                          </div>
                          <div className="col-md-2">
                              <label className="col-form-label">{CommonUtil.getMessageText(Constants.CARD_CVV,"Card CVV")}</label>
                              <div id="card-cvv" className="field form-control" placeholder="Card CVV"></div>
                              <span style={{color:"red"}} id={"spnCardCvv"}></span>
                          </div>
                          <div className="col-md-2">
                              <label className="col-form-label">{CommonUtil.getMessageText(Constants.EXPIRY_DATE,"Expiry Date")}</label>
                              <div id="card-expiry" className="field form-control" placeholder="Expiry Date"></div>
                              <span style={{color:"red"}} id={"spnCardDate"}></span>
                          </div>
                          <div className="col-md-12 mt-3">
                              <div className="form-check ps-1">
                                  <input className="me-1 mt-1" type="checkbox" id="isForPayment" />
                                  <label className="form-check-label" htmlFor="isForPayment">Default payment card</label>
                              </div>
                          </div>
                        </div>
                    </div>
                    <input type={"button"} className={"btn btn-success"} value={"Send"} style={{display:"none"}}  onClick={this.onClickPay}/>
                </>
            )
        }
    }
